import React, { useGlobal, useEffect } from 'reactn';
import { Route, Redirect, useLocation } from 'react-router-dom';

const PrivateRoute = ({user, children, ...routeProps}) => {
  const [lastUrlWithoutUser, setLastUrlWithoutUser] = useGlobal('lastUrlWithoutUser')

  let currentPath = useLocation().pathname + useLocation().search

  useEffect(() => {
    if (!user && currentPath != '/') setLastUrlWithoutUser(currentPath)
  }, [])

  return (
    <Route {...routeProps}>
      { user ? children : <Redirect to="/login"/> }
    </Route>
  );
}

export default PrivateRoute;
